import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { useForm } from 'react-hook-form';
import { UploadFile } from '../components/Upload';
import api from '../utils/functions/api';
import { swalErrorBtn } from '../helpers/swalHelper';
import InvoiceListApi from '../service/invoice.api';
import TableUploadUtan from '../components/TableUpload/TableUploadUtan';
import TableUploadJV from '../components/TableUpload/TableUploadJV';
import { getStorage } from '../utils/functions/localstorage';
import jwtDecode from 'jwt-decode';
import UploadInvoiceDialog from '../components/dialogs/uploadFile/UploadInvoiceDialog';
import TableUploadDefault from '../components/TableUpload/TableUploadDefault';
import TableUploadSchool from '../components/TableUpload/TableUploadSchool';
import TableUploadDefaultSalesman from '../components/TableUpload/TableUploadDefaultSalesman';

function UploadMerchant() {

  const [importFile, setImportFile] = useState(null);
  const { handleSubmit } = useForm();
  const [showData, setShowData] = useState();
  const [tokenCustomer, setTokenCustomer] = useState(getStorage('token'));

  const [openDialogImport, setOpenDialogImport] = useState(false);

  const decoded = jwtDecode(tokenCustomer);
  const customerName = decoded.NAME;
  const isJV = decoded.IS_JV;

  const resetShowData = () => {
    setShowData(null);
  };

  const openDialogInvoice = () => {
    setOpenDialogImport(true);
  }

  const closeDialogInvoice = () => {
    setOpenDialogImport(false);
  }

  const getExampleExcel = async () => {
    try {
      const path = `${process.env.REACT_APP_API_URL}/templates/example/`;
      const { data } = await api.get(path, { responseType: 'arraybuffer' });

      const downloadLink = document.createElement('a');
      const blob = new Blob([data]);
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = 'แบบฟอร์มตัวอย่าง.xlsx';
      downloadLink.click();
    } catch (error) {
      swalErrorBtn({ title: `ไม่สามารถดาวน์โหลดได้ เนื่องจาก ${error}` });
      console.log(error);
    }
  };

  const showDataList = async () => {
    try {
      if (importFile) {
        const formData = new FormData();
        formData.append('merchant_id', '2022');
        formData.append('file', importFile);
        const data = await InvoiceListApi.extractFileApi(formData);
        if (data) {
          setShowData(data);
          // console.log(data);
        }
      }
    } catch (error) {
      console.log(error);
      const errMessage = error.message;
      let alertMessage;
      switch (errMessage) {
        case 'inv_start_date is invalid':
          alertMessage = 'วันที่ใบแจ้งหนี้ไม่ถูกต้อง';
          break;
        case 'inv_due_date is invalid':
          alertMessage = 'วันครบกำหนดชำระเงินไม่ถูกต้อง';
          break;
        case 'amount must be a number':
          alertMessage = 'ยอดชำระต้องเป็นตัวเลข';
          break;
        case 'amount is invalid and must not have more than 2 decimal places':
          alertMessage = 'ยอดชำระต้องมีทศนิยมไม่เกิน 2 ตำแหน่ง';
          break;
        case 'Email is invalid':
          alertMessage = `
          อีเมลไม่ถูกต้อง
          ตัวอย่างรูปแบบที่ถูกต้อง "example@example.com"
          `;
          break;
        case 'TaxId must be 13 digit number':
          alertMessage = 'เลขประจำตัวผู้เสียภาษีต้องมี 13 หลัก';
          break;
        case 'invoice_no is required and must not more than 50 number':
          alertMessage = 'เลขที่ใบแจ้งหนี้และต้องไม่เกิน 50 ตัวอักษร';
          break;
        case 'postalCode must be 5 digit number':
          alertMessage = 'รหัสไปรษณีย์ต้องมี 5 หลัก';
          break;
        case 'FOUND_EMPTY_CELL':
          alertMessage = `
          พบข้อมูลว่าง
          กรุณากรอกข้อมูลให้ครบถ้วนก่อนทำการอัปโหลด
          `;

          break;
        default:
          alertMessage = 'แสดงข้อมูลที่อัปโหลดไม่สำเร็จ';
          break;
      }
      swalErrorBtn({ title: alertMessage });
    }
  };
  // console.log('showData', showData);
  return (
    <div>
      <div className="my-2 ml-2">
        <div className="text-lg font-light mt-5 selection:flex items-center">
          <div className="flex justify-between">
            <div>
              <div className="py-6 text-xl">อัปโหลดข้อมูล</div>
            </div>
            <div className='flex gap-3'>
              {isJV && (
                <div className='py-6'>
                  <Button
                    onClick={() => openDialogInvoice()}
                    variant="outlined"
                  >
                    นำเข้าข้อมูล
                  </Button>
                </div>
              )}
              <div className="py-6">
                <Button
                  onClick={getExampleExcel}
                  target="_blank"
                  download
                  variant="outlined"
                >
                  แบบฟอร์มตัวอย่าง
                </Button>
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-center">
            <div className="w-full md:w-1/2">
              <UploadFile
                setFile={setImportFile}
                resetShowData={resetShowData}
              />
            </div>
          </div>
          <form onSubmit={handleSubmit(showDataList)}>
            {' '}
            <div className="flex flex-row justify-center">
              <div className="w-full md:w-1/2">
                {importFile && !showData && (
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    aria-label="แสดงข้อมูลที่อัปโหลด"
                  >
                    <div className="text-white">แสดงข้อมูลที่อัปโหลด</div>
                  </Button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="flex-1">
        {renderTable(customerName, showData)}
      </div>

      <UploadInvoiceDialog
        open={openDialogImport}
        onClose={closeDialogInvoice}
      />

    </div>
  );
}

const renderTable = (customerName, showData) => {
  if (!showData?.data) return null;

  switch (showData?.templateName) {
    case "บริษัท ทูมอโร่สไมล์ จำกัด":
    case "JV":
    case "ทดสอบ e-tax":
    case "บริษัท ทดสอบ PDF จำกัด":
    case "โรงเรียนทดสอบ":
      return (
        <TableUploadJV
          allowEdit={showData.allowEdit}
          showData={showData.data}
          statusETax={showData.statusETax}
        />
      );

    case "บริษัท ยูตัน โฮม จำกัด":
    case "ยูตัน โฮม":
      return (
        <TableUploadUtan
          allowEdit={showData.allowEdit}
          showData={showData.data}
          statusETax={showData.statusETax}
        />
      );

    case "โรงเรียน":
      return (
        <TableUploadSchool
          allowEdit={showData.allowEdit}
          showData={showData.data}
          statusETax={showData.statusETax}
        />
      );

    case 'Default - Salesman':
      return (
        <TableUploadDefaultSalesman
          allowEdit={showData.allowEdit}
          showData={showData.data}
          statusETax={showData.statusETax}
        />
      );

    default:
      return (
        <TableUploadDefault
          allowEdit={showData.allowEdit}
          showData={showData.data}
          statusETax={showData.statusETax}
        />
      );
  }
};

export default UploadMerchant;
